import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const LongShortQuestion = ({
  isRequired,
  setIsRequired,
  questionType,
  answerText,
  setAnswerText,
}) => {
  const { t } = useTranslation();

  const [placeholder] = useState("Please input placeholder for this question");

  const isLongAnswer = questionType?.value === "long";

  return (
    <>
      <div className="mb-4">
        <textarea
          className={`w-full text-base focus:outline-none bg-white rounded-xl border border-solid border-stone-200 px-3 pt-3 ${
            isLongAnswer ? "min-h-[142px] pb-28" : "min-h-[80px] pb-12"
          }`}
          placeholder={placeholder}
          onChange={(e) => setAnswerText(e.target.value)}
          value={answerText}
        />
      </div>

      <div className="space-y-4 mb-4">
        <div className="flex items-center gap-2">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isRequired}
              onChange={() => setIsRequired(!isRequired)}
            />
            <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none  rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
          <span className="text-gray-500">{t("base.required")}</span>
        </div>
      </div>
    </>
  );
};

export default LongShortQuestion;
